import React from "react";
import i18n from "../../../../i18n/i18n";
import FerryForm from "../ferryForm/ferryForm";
import {FerryModel} from "../../../models/ferry";
import ModifyItem from "../../dictionary/modifyItem/modifyItem";
import {FerryService} from "../../../services/ferryService";
import {withRouter} from "react-router";


class ModifyFerry extends ModifyItem<FerryModel> {
    constructor(props: any) {
        super(props);
    }

    async componentDidMount() {
        this.getItem(await FerryService.getFerry(this.props.match.params?.id));
    }

    render() {
        return (
            <div className="modify-ferry modify-record">
                <div className="content">
                    {this.renderHeader(i18n.t("dictionaries.ferries.actions.modifyFerry.header"))}
                    {this.renderContent(<FerryForm isUpdate={true} ferryData={this.state.item}/>)}
                </div>
            </div>
        );
    }
}
export default withRouter(ModifyFerry);

